<template>
  <div v-if="viewport" class="robot">
    <div>
      <banner :nav-index="3">
        <template slot="banner">
          <div class="banner">
            <div class="center" :style="{'will-change': 'transform',transform: `translate3d(0,${transLateY}px,0)`}">
              <div class="text">
                <h1>
                  Emotional Intelligence
                </h1>
                <div class="line"></div>
                <p>
                    Merging humanoid robot and interactive wearable technology to enable  ‘twin interaction’ of emotion and action between human and robots.
                    Turing robots into container and extension of human emotion via enhancement of sensory capabilities of human, thereby allowing a remote,
                    realistic and interactive perceptual experience between human and robots.
                </p>
              </div>
            </div>
          </div>
        </template>
      </banner>
    </div>
    <div style="position: relative;z-index: 2;background-color: #fff">
      <div>
        <chaperonage></chaperonage>
      </div>
      <div class="footer-box">
        <relation></relation>
      </div>
    </div>

  </div>
  <div v-else class="phone-wrap">
    <div class="background">
      <div class="nav">
        <div class="logo">
          <img src="@/assets/phone/phone-logo.png">
        </div>
        <div @click="onList" class="fork">
          <span class="iconfont icon-liebiaoshitucaidan"></span>
        </div>
      </div>
      <div class="title">
        <h1>Emotional Intelligence</h1>
      </div>

      <div v-show="list" class="list">
        <phoneNav @onHide="onHide"></phoneNav>
      </div>
    </div>
    <div class="text">
      <p>Merging humanoid robot and interactive wearable technology to enable  ‘twin interaction’ of emotion and action between human and robots.
          Turing robots into container and extension of human emotion via enhancement of sensory capabilities of human, thereby allowing a remote,
          realistic and interactive perceptual experience between human and robots.
      </p>
    </div>
    <div class="smart">
      <div class="chaperonage">
        <img src="@/assets/phone/chaperonage2.png">
      </div>
      <div class="introduce">
        <div>
          <h4>Emotional robot</h4>
          <div class="line"></div>
          <p>
            Emotional companion<br /> robot based on brain-<br /> inspired intelligence<br /> 
          </p>
        </div>
      </div>
    </div>
    <div class="smart reverse">
      <div class="chaperonage">
        <img src="@/assets/phone/shushuai1.png">
      </div>
      <div class="introduce">
        <div>
          <h4>
          Smart<br /> Wearable
          </h4>
          <div class="line"></div>
          <p>
            Robot control training<br /> system based on<br /> human body data<br /> collection.
          </p>
        </div>
      </div>
    </div>
    <div class="smart">
      <div class="chaperonage">
        <img src="@/assets/phone/shuaishuai2.png">
      </div>
      <div class="introduce">
        <div>
          <h4>
            Affective Empowering AI
          </h4>
          <div class="line"></div>
          <p class="broad">
              Emotional Expression <br />with Human-Machine<br /> Collaboration
          </p>
        </div>
      </div>
    </div>
    <div class="muscle">
      <img src="@/assets/inter_3.gif">
    </div>
    <div class="footer">
      <phoneFooter></phoneFooter>
    </div>
  </div>
</template>

<script>
import banner from '@/components/banner'
import chaperonage from './components/chaperonage'
import relation from '@/components/footer'
import phoneNav from '@/components/phoneNav/index'
import phoneFooter from "@/components/phoneFooter";

export default {
  name: "robot.vue",
  components: {
    phoneNav,
    banner,
    chaperonage,
    relation,
    phoneFooter,
  },
  watch: {
    screenWidth: function (n, o) {
      if (n <= 1024) {
        this.viewport = false
      } else {
        this.viewport = true
      }
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll) // 监听页面滚动
    this.screenWidth = document.body.clientWidth
    if (document.documentElement.clientWidth < 1280) {
      this.viewport = false
    }
    window.onresize = () => {
      //屏幕尺寸变化
      return (() => {
        this.screenWidth = document.body.clientWidth

      })()
    }
  },
  data() {
    return {
      toTop: 0,
      transLateY: 0,
      viewport: true,
      screenWidth: null,
      list: false,
    }

  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if (scrollTop < 900) {
        if (this.toTop <= scrollTop) {
          this.transLateY = scrollTop / 10
        } else {
          this.transLateY = -scrollTop / 10
        }
      }
      this.toTop = scrollTop
    },

    onList() {
      setTimeout(() => {
        this.list = true
      }, 200)

    },

    onHide() {
      setTimeout(() => {
        this.list = false
      }, 200)

    },

  }
}
</script>

<style scoped>

.muscle {
  line-height: 0;
  position: relative;
}

.muscle img {
  width: 100%;
}


.banner .center {
  margin: 0 auto;
  width: 1200px;
}

.center .text {
  padding-top: 150px;
}

.center .text h1 {
  font-weight: 700;
  font-size: 42px;
  line-height: 72px;
  color: #FFFFFF;
}

.center .text .line {
  margin-top: 42px;
  width: 60px;
  height: 6px;
  background-color: #FFFFFF;
}

.center .text p {
  margin-top: 50px;
  font-size: 24px;
  line-height: 50px;
  color: #FFFFFF;
  opacity: 0.8;
}

.footer-box {
  padding-top: 190px;
}

.nav {
  display: flex;
  justify-content: space-between;
  padding: 1.14rem 0.6rem 0;
}

.nav .logo {
  display: flex;
  align-items: center;
  height: 0.43rem;
}

.nav .logo img {
  height: 0.35rem;
}

.nav .fork {
  height: 0.43rem;
  line-height: 0.43rem;
  color: #FFFFFF;
}

.nav .fork .iconfont {
  font-size: 0.36rem;
}

.list {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9;
}

.background {
  background-image: url("../../assets/phone/chaperonage.jpg");
  background-repeat: no-repeat;
  background-size: cover;
}

.background .title {
  padding: 1.84rem 0 2.06rem 0.7rem;
}

.background .title h1 {
  font-style: normal;
  font-weight: 600;
  font-size: 0.46rem;
  line-height: 0.61rem;
  color: #FFFFFF;
}

.phone-wrap .text {
  padding: 0.6rem;
}

.phone-wrap .text p {
  font-style: normal;
  font-weight: 400;
  font-size: 0.24rem;
  line-height: 0.4rem;
  color: #111111;
}

.smart {
  padding-bottom: 0.8rem;
  display: flex;
  line-height: 0;
}


.reverse {
  display: flex;
  flex-direction: row-reverse;
}

.smart .chaperonage {
  line-height: 0;
}

.smart .chaperonage img {
  width: 4.7rem;
}

.smart .introduce {
  margin-left: 0.28rem;
  display: flex;
  align-items: center;
}

.reverse .introduce {
  margin-left: 0.4rem;
}


.smart .introduce h4 {
  font-style: normal;
  font-weight: 600;
  font-size: 0.32rem;
  line-height: 0.42rem;
}

.smart .introduce .line {
  margin-top: 0.2rem;
  width: 0.24rem;
  height: 0.03rem;
  background-color: #000000;
}

.smart .introduce p {
  margin-top: 0.2rem;
  font-style: normal;
  font-weight: 400;
  font-size: 0.2rem;
  line-height: 0.4rem;
  color: #111111;
  opacity: 0.5;
}

.smart .introduce .broad {
  /*width: 1.45rem;*/
}
</style>
